import { Modal } from "react-bootstrap";
import { faXmark, faListCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Position from "@serie3/freelancesplaceapi/Entity/Billing/Position";
import PositionDomain from "@serie3/freelancesplaceapi/Domain/Billing/Outgoing/Position";

const PositionView = ({ show, setShow, position }) => {
  if (!position) position = Position;

  const nett     = PositionDomain.calculatePositionNett(position);
  const taxtotal = PositionDomain.calculatePositionTax(position);
  const gross    = PositionDomain.calculatePositionGross(position);

  const MetaItem = ({ label, value }) => (
    <div style={{
      background: "#fff", borderRadius: "10px", padding: "12px 16px",
      boxShadow: "0 1px 4px rgba(0,0,0,0.06)", textAlign: "center",
    }}>
      <div style={{ fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "4px" }}>
        {label}
      </div>
      <div style={{ fontWeight: 700, fontSize: "1rem", color: "#212121" }}>{value}</div>
    </div>
  );

  const TotalRow = ({ label, value, accent }) => (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "9px 0",
      borderTop: accent ? "2px solid #e0e0e0" : "1px solid #f0f0f0",
    }}>
      <span style={{ fontSize: "0.88rem", fontWeight: 500, color: "#9e9e9e" }}>{label}</span>
      <span style={{ fontSize: accent ? "1.05rem" : "0.92rem", fontWeight: accent ? 800 : 600, color: accent || "#424242" }}>
        € {value}
      </span>
    </div>
  );

  return (
    <>
      <style>{`
        .position-view-modal {
          border-radius: 14px !important; overflow: hidden !important;
          border: none !important; box-shadow: 0 8px 40px rgba(0,0,0,0.18) !important;
        }
      `}</style>
      <Modal size="lg" show={show} onHide={() => setShow(false)} contentClassName="position-view-modal">

        {/* Header */}
        <div style={{
          background: "linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)",
          padding: "18px 24px", display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{
              width: "32px", height: "32px", borderRadius: "8px",
              background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center",
              justifyContent: "center", color: "#fff", fontSize: "0.9rem",
            }}>
              <FontAwesomeIcon icon={faListCheck} />
            </div>
            <span style={{ fontWeight: 700, fontSize: "1rem", color: "#fff" }}>
              {position.titel || "Position"}
            </span>
          </div>
          <button type="button" onClick={() => setShow(false)} style={{
            background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "8px",
            width: "30px", height: "30px", display: "flex", alignItems: "center",
            justifyContent: "center", cursor: "pointer", color: "#fff",
          }}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        {/* Body */}
        <div style={{ background: "#f8f9fb", padding: "24px", display: "flex", flexDirection: "column", gap: "16px" }}>

          {/* Description */}
          {position.beschreibung && (
            <div style={{ background: "#fff", borderRadius: "10px", padding: "14px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", fontSize: "0.92rem", color: "#616161", lineHeight: 1.7 }}>
              {position.beschreibung}
            </div>
          )}

          {/* Price / Amount / Tax */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
            <MetaItem label="Price (€)" value={position.preis} />
            <MetaItem label="Amount" value={position.multiplikator} />
            <MetaItem label="Tax (%)" value={position.steuersatz} />
          </div>

          {/* Totals */}
          <div style={{ background: "#fff", borderRadius: "10px", padding: "12px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
            <TotalRow label="Net" value={nett} />
            <TotalRow label="Tax" value={taxtotal} />
            <TotalRow label="Gross" value={gross} accent="#2e7d32" />
          </div>
        </div>

        {/* Footer */}
        <div style={{
          background: "#fff", borderTop: "1px solid #f0f0f0",
          padding: "14px 24px", display: "flex", justifyContent: "flex-end",
        }}>
          <button onClick={() => setShow(false)} style={{
            padding: "8px 18px", background: "#f5f5f5", color: "#424242",
            border: "none", borderRadius: "8px", fontWeight: 600,
            fontSize: "0.88rem", cursor: "pointer",
          }}>
            Close
          </button>
        </div>

      </Modal>
    </>
  );
};

export default PositionView;
